import angular from 'angular';
import moment from 'moment';
import {
    createEmptyMovimentacaoAdmissaoForm,
    IMovimentacaoAdmissaoFormBindings,
    IMovimentacaoAdmissaoFormModel,
    IMovimentacaoAdmissaoFormState
} from './movimentacoes-admissoes-form.model';
import {
    isMovimentacaoEventoDecimal,
    isMovimentacaoEventoDias,
    isMovimentacaoEventoHoras,
    isMovimentacaoEventoMonetario,
    MOVIMENTACAO_REFERENCIA_MAX_LENGTH
} from '../../../../Movimentacoes/helpers/movimentacoes-value.helpers';

export class MovimentacoesAdmissoesFormController implements angular.IController, IMovimentacaoAdmissaoFormBindings {
    static $inject = ['$scope'];

    public model: IMovimentacaoAdmissaoFormModel;
    public formRef?: angular.IFormController;
    public admissionDate: string | Date | null = null;
    public disabled = false;
    public onValidityChange?: (args: { state: IMovimentacaoAdmissaoFormState }) => void;

    public readonly referenciaMaxLength = MOVIMENTACAO_REFERENCIA_MAX_LENGTH;
    public vigenciaFinalInvalida = false;
    public meses = [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' }
    ];
    public anos: number[] = [];

    constructor(private $scope: angular.IScope) { }

    public $onInit(): void {
        this.ensureModel();
        this.buildAnos();
        this.setupWatchers();
    }

    public $onChanges(changes: angular.IOnChangesObject): void {
        if (changes.admissionDate) {
            this.buildAnos();
            this.emitState();
        }
    }

    public setVigencia(vigencia: 1 | 2 | 3): void {
        this.model.vigencia = vigencia;
        if (vigencia !== 3) {
            this.model.vigenciamesfinal = null;
            this.model.vigenciaanofinal = null;
            this.vigenciaFinalInvalida = false;
        }
        this.emitState();
    }

    public isEventoHoras(): boolean {
        return isMovimentacaoEventoHoras(this.model?.evento);
    }

    public isEventoDias(): boolean {
        return isMovimentacaoEventoDias(this.model?.evento);
    }

    public isEventoMonetario(): boolean {
        return isMovimentacaoEventoMonetario(this.model?.evento);
    }

    public isEventoDecimal(): boolean {
        return isMovimentacaoEventoDecimal(this.model?.evento);
    }

    public onVigenciaChange(): void {
        this.emitState();
    }

    private setupWatchers(): void {
        this.$scope.$watch(() => this.model, () => {
            this.emitState();
        }, true);
        this.$scope.$watch(() => this.formRef && this.formRef.$valid, () => {
            this.emitState();
        });
    }

    private emitState(): void {
        this.vigenciaFinalInvalida = this.isVigenciaThreeWithInvalidFinalPeriodo();
        const formValid = this.formRef ? this.formRef.$valid : false;
        const state: IMovimentacaoAdmissaoFormState = {
            valid: formValid && !this.vigenciaFinalInvalida,
            vigenciaFinalInvalida: this.vigenciaFinalInvalida
        };

        if (this.onValidityChange) {
            this.onValidityChange({ state });
        }
    }

    private ensureModel(): void {
        if (this.model) {
            return;
        }

        this.model = createEmptyMovimentacaoAdmissaoForm();
    }

    private buildAnos(): void {
        const anoAtual = new Date().getFullYear();
        const anoAdmissao = this.getAdmissionMoment()?.year() || anoAtual;
        const anoInicial = Math.min(anoAtual, anoAdmissao);
        const anoFinal = Math.max(anoAtual, anoAdmissao) + 2;
        this.anos = [];

        for (let ano = anoInicial; ano <= anoFinal; ano++) {
            this.anos.push(ano);
        }
    }

    private isVigenciaThreeWithInvalidFinalPeriodo(): boolean {
        if (this.model.vigencia !== 3) {
            return false;
        }

        if (!this.model.vigenciamesfinal || !this.model.vigenciaanofinal) {
            return false;
        }

        const periodoAdmissao = this.getAdmissionPeriodo();
        if (!periodoAdmissao) {
            return false;
        }

        const finalAno = Number(this.model.vigenciaanofinal);
        const finalMes = Number(this.model.vigenciamesfinal);

        if (finalAno > periodoAdmissao.ano) {
            return false;
        }

        if (finalAno < periodoAdmissao.ano) {
            return true;
        }

        return finalMes <= periodoAdmissao.mes;
    }

    private getAdmissionPeriodo(): { mes: number; ano: number } | null {
        const admissionMoment = this.getAdmissionMoment();
        if (!admissionMoment) {
            return null;
        }

        return {
            mes: admissionMoment.month() + 1,
            ano: admissionMoment.year()
        };
    }

    private getAdmissionMoment(): moment.Moment | null {
        if (!this.admissionDate) {
            return null;
        }

        const parsed = this.admissionDate instanceof Date
            ? moment(this.admissionDate)
            : moment(this.admissionDate, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);

        return parsed.isValid() ? parsed : null;
    }
}
